import { FC } from "react"

import { PlusOutlined } from "@ant-design/icons"
import { Table, Flex, InputNumber , Typography, Button, DatePicker, TimeRangePickerProps, Divider } from "antd"
import dayjs from "dayjs"

import { IBulkOrder, IBulkOrderFuelCreate, IShippingSchedule } from "@/types/IBulkOrder"

const { RangePicker } = DatePicker
const { Text } = Typography

export interface ShippingScheduleTableProps {
  bulkOrder: IBulkOrder
  bulkOrderFuel: IBulkOrderFuelCreate
  additionalColumns?: any[]
  onChange(bulkOrderFuelGuid: string, shippingScheduleGuid: string, name: string, value: string): void
  onAdd(guid: string): void
}

export const ShippingScheduleTable: FC<ShippingScheduleTableProps> = (props) => {
  const { bulkOrder, bulkOrderFuel, additionalColumns, onAdd, onChange } = props

  const onСhangeInput = (e: any) => {
    if (bulkOrderFuel.guid && e.target) {
      onChange(bulkOrderFuel.guid, e.target.id, e.target.name, e.target.value)
    }
  }

  const onChangeRangePicker = (dates: any, shippingScheduleGuid: string, name: string) => {
    if (bulkOrderFuel.guid) {
      onChange(bulkOrderFuel.guid, shippingScheduleGuid, name, dates)
    }
  }
  const onAddShippingScheduleHandler = () => {
    if (!bulkOrderFuel.guid) {
      return
    }
    onAdd(bulkOrderFuel.guid)
  }

  const disabledDate: TimeRangePickerProps["disabledDate"] = (current) => {
    return current && current < dayjs().add(-1, "day")
  }

  const fuelColumns = [
    {
      title: "Период",
      dataIndex: "period",
      key: "period",
      width: 350,
      render: (_: any, schedule: IShippingSchedule) =>
      <RangePicker 
        style={{ width: "100%" }}
        format={"DD-MM-YYYY"}
        allowClear={false}
        id={schedule.guid}
        name={`period_${bulkOrderFuel.guid}`}
        defaultValue={[dayjs(schedule.startDate), dayjs(schedule.endDate)]}
        disabledDate={disabledDate}
        onChange={(dates: any) => onChangeRangePicker(dates, schedule.guid, `period_${bulkOrderFuel.guid}`)}
      />,
      isVisible: true
    },
    {
      title: "Количество, тн",
      dataIndex: "quantity",
      key: "quantity",
      width: 150,
      render: (_: any, schedule: IShippingSchedule) =>
        <InputNumber 
          id={schedule.guid}
          name={`quantity_${bulkOrderFuel.guid}`}
          defaultValue={schedule.quantity}
          min={0}
          style={{ width: "100%" }}
          parser={(value) => value === "" ? value.replace("", "0") as unknown as number : value as unknown as number}
          onChangeCapture={onСhangeInput}
        />,
      isVisible: true
    },
    {
      title: "Цена",
      dataIndex: "price",
      key: "price",
      render: (_: any, schedule: IShippingSchedule) =>
        <InputNumber  
          id={schedule.guid}
          name={`price_${bulkOrderFuel.guid}`}
          min={0}
          style={{ width: "100%" }}
          defaultValue={schedule.price ? schedule.price : undefined}
          placeholder="на дату отгрузки"
          onChangeCapture={onСhangeInput}
        />,
      isVisible: true
    }
  ]

  return (
    <>
      <Flex align={"center"}>      
        <Text strong type={"secondary"} style={{ paddingRight: "1rem" }}>{bulkOrder.depotName} - {bulkOrder.deliveryTypeText} - {bulkOrderFuel.fuelTypeName}</Text>
        <Button
          type="primary" 
          size={"middle"}
          icon={<PlusOutlined />}        
          shape="circle"
          onClick={onAddShippingScheduleHandler}
        />
        <Text style={{ paddingLeft: "0.25rem" }}>Добавить еще</Text>
      </Flex>
      <Table
        columns={[...fuelColumns.filter(c => c.isVisible), ...(additionalColumns ?? [])]}
        rowKey={(fuel) => crypto.randomUUID()}
        dataSource={bulkOrderFuel.shippingSchedules}
        pagination={false}
      />
       <Divider />
    </>
  )
}